export enum UnassignOption {
  UnassignAll = 'unassign_all',
  KeepAssigned = 'keep_assigned'
}

export enum Plan {
  Standard = 'standard',
  Plus = 'plus'
}
